// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"719":"624af5ef","875":"881897d6"}[chunkId] + ".css";
};